/*
 * Model class Assistance
 */
export default class Assistance {
    constructor(content, scan_policy) {
        this.scan_policy = scan_policy;
        this.content = {
            darkweb: {},
            publicweb: {}
        };

        for (let i in content) {
            let index = Object.keys(this.content)[i];

            if (index !== undefined) {
                this.content[index].title = content[i].title;

                this.content[index].groups = {personal: {}, financial: {}, other: {}};

                if (content[i].groups[0] !== undefined) {
                    this.content[index].groups.personal = {
                        title: content[i].groups[0].title,
                        text: content[i].groups[0].text
                    };
                }

                if (content[i].groups[1] !== undefined) {
                    this.content[index].groups.financial = {
                        title: content[i].groups[1].title,
                        text: content[i].groups[1].text
                    };
                }

                if (content[i].groups[2] !== undefined) {
                    this.content[index].groups.other = {
                        title: content[i].groups[2].title,
                        text: content[i].groups[2].text
                    };
                }
            }
        }
    }

    //Finds text for personal or financial asisstance data
    create(where, match) {
        let personal_or_financial = '';

        for (let i in this.scan_policy) {
            if (match == this.scan_policy[i].target_dbfield) {
                personal_or_financial = parseInt(this.scan_policy[i].financial) === 1 ? 'financial' : 'personal';

                if (!parseInt(this.scan_policy[i].financial) && this.scan_policy[i].target_dbfield !== 'email') {
                    personal_or_financial = 'other'
                }
            }
        }

        return this.content[where].groups[personal_or_financial];
    }
}